export const login = Object.freeze({
  login: '/ucenter/oauth/token',
  getTokenByCode: (code) => `/ucenter/oauth/data_center/get_token/${code}`,
  wxauth: '/wxauth'
})

export const user = Object.freeze({
  getMenu: '/ucenter/user/current/menu',
  getInfo: '/ucenter/user/current',
  logOut: '/ucenter/oauth/token',
  getUserDriver: '/ucenter/oauth/driver',
  getSalt: '/ucenter/oauth/salt',
  getVImg: '/ucenter/oauth/verify/code'
})

export const assess = Object.freeze({
  gasDaily: '/cnpc/total/check/gas/daily',
  gasDailyDetail: '/cnpc/total/check/gas/daily/detail',
  distribution: '/cnpc/total/check/gas/distribution',
  distributionDetail: '/cnpc/total/check/gas/distribution/detail',
  carSign: '/cnpc/total/check/car/sign',
  carSignDetail: '/cnpc/total/check/car/sign/detail',
  signDetail: '/cnpc/total/check/car/sign/ratio/detail'
})

export const homeTj = Object.freeze({
  collectData: '/cnpc/total/collect/data',
  isPre: '/cnpc/total/is/pre',
  diff: '/cnpc/total/gas/distribution/diff',
  isOrder: '/cnpc/total/is/order',
  routeOrder: '/cnpc/total/route/order',
  pre: '/cnpc/total/pre',
  price: 'cnpc/total/gas/distribution/price',
  warn: '/cnpc/total/warn',
  preRatio: '/cnpc/total/pre/ratio',
  optimalGas: '/cnpc/total/optimal/gas',
  optimalDistribution: '/cnpc/total/optimal/distribution'
})

export const distributionAssess = Object.freeze({
  basUrl: 'cnpc/gas/evaluate',
  getList: 'cnpc/gas/evaluate/list'
})

export const stockReceipt = Object.freeze({
  basUrl: '/cnpc/gas/tank/stock/receipt',
  parmUrl: (id) => `/cnpc/gas/tank/stock/receipt/${id}`
})

export const gasRequireOrder = Object.freeze({
  basUrl: '/cnpc/gas/require/order',
  parmUrl: (id) => `/cnpc/gas/require/order/${id}`
})

export const holiday = Object.freeze({
  basUrl: '/cnpc/holiday',
  getUrl: '/cnpc/holiday',
  delUrl: (id) => `/cnpc/holiday/${id}`,
  parmUrl: (id) => `/cnpc/holiday/${id}`
})

export const common = Object.freeze({
  outputData: '/cnpc/otherbus/excel/list'
})

export const users = Object.freeze({
  update: (userId) => `/ucenter/user/${userId}`
})

export const gasPromotion = Object.freeze({
  basUrl: '/cnpc/gas/promotion/list',
  inputUrl: '/cnpc/otherbus/import/gas/promotion',
  outputTemplate: '/cnpc/otherbus/excel/promotion/template',
  delData: '/cnpc/gas/promotions/del'
})

export const countData = Object.freeze({
  gasInventory: '/cnpc/gastank/current/inventory',
  signCar: '/cnpc/car/effective/numbers',
  daily: '/cnpc/gas/daily/error/numbers',
  distributionFreights: '/cnpc/gas/distribution/freights',
  distributionWeights: '/cnpc/gas/distribution/weights',
  carData: '/cnpc/car/numbers/mileage',
  distributionEfficiency: '/cnpc/gas/distribution/sort'
})

export const dispatchHomeCount = Object.freeze({
  basUrl: '/cnpc/total',
  yearFreight: '/cnpc/total/year/freight',
  lossRatio: '/cnpc/total/loss/ratio'
})

export const warningInvoicing = Object.freeze({
  basUrl: '/cnpc/gas/daily/count/by/group'
})

export const gasDispatchStatus = Object.freeze({
  getGasOilData: '/cnpc/gas/oil/running',
  getOrderData: '/cnpc/gas/distribution/list/by/ids'
})

export const dictionary = Object.freeze({
  basUrl: '/cnpc/dictionary/get/group/dic',
  parmUrl: (id) => `/cnpc/dictionary//upd/item/${id}`
})

export const serverStatus = Object.freeze({
  basUrl: '/cnpc/gas/interface/status',
  updateStatus: (id, flag) => `/cnpc/gas/interface/status/${id}/${flag}`,
  getPsdStatus: '/cnpc/gas/interface/status/empty/hour',
  getYwyStatus: '/cnpc/gas/interface/status/tank/warning'
})

export const company = Object.freeze({
  basUrl: '/cnpc/gas/company/list'
})

export const interfaceStatus = Object.freeze({
  basUrl: (flag) => `/cnpc/gas/interface/status/${flag}`
})

export const role = Object.freeze({
  basUrl: '/ucenter/sys/role',
  parmUrl: (roleId) => `/ucenter/sys/role/${roleId}`
})

export const carAgentGasGroup = Object.freeze({
  basUrl: '/cnpc/carAgent2GasGroup',
  parmUrl: (id) => `/cnpc/carAgent2GasGroup/${id}`
})

export const group = Object.freeze({
  basUrl: '/cnpc/group/list',
  carTeam: (id) => `/cnpc/car/agent/${id}`,
  getGroupCarTeams: '/cnpc/car/agent/list',
  groupUrl: '/cnpc/group',
  groupParmUrl: (id) => `/cnpc/group/${id}`
})

export const carAgent = Object.freeze({
  basUrl: '/cnpc/car/agent',
  parmUrl: (id) => `/cnpc/car/agent/${id}`
})

export const depotLoadTime = Object.freeze({
  basUrl: '/cnpc/depot/halfHour/sort',
  getDistribution: '/cnpc/depot/halfHour/sort/detail',
  getDeoptList: '/cnpc/depot/havingDis'
})

export const defaultDepot = Object.freeze({
  basUrl: '/cnpc/gas/default/depot',
  parmUrl: (id) => `/cnpc/gas/default/depot/${id}`,
  warning: '/cnpc/gas/default/depot/none',
  outputTemplate: '/cnpc/depot/import/default/template'
})

export const depotdiff = Object.freeze({
  basUrl: '/cnpc/gas/distribution/depot/diff',
  getCrossReasons: '/cnpc/gas/distribution/cross/reasons',
  updateCrossReason: '/cnpc/gas/distribution/cross/reason',
  outPut: '/cnpc/otherbus/excel/distribution/cross/reason'
})

export const distance = Object.freeze({
  basUrl: '/cnpc/gas/distance',
  parmUrl: (id) => `/cnpc/gas/distance/${id}`,
  warning: '/cnpc/gas/distance/none',
  inputUrl: '/cnpc/depot/import/distance',
  outputTemplate: '/cnpc/depot/import/distance/template'
})

export const depotDistance = Object.freeze({
  basUrl: '/cnpc/depot/transport'
})

export const gasStrand = Object.freeze({
  basUrl: '/cnpc/gas/strand',
  parmUrl: (id) => `/cnpc/gas/strand/${id}`,
  outputTemplate: '/cnpc/gas/import/strand/template',
  inputUrl: '/cnpc/gas/import/strand'
})

export const gasTankStrand = Object.freeze({
  basUrl: '/cnpc/gastank/strand',
  parmUrl: (id) => `/cnpc/gastank/strand/${id}`
})

export const gas = Object.freeze({
  basUrl: '/cnpc/gas',
  parmUrl: (gasId) => `/cnpc/gas/${gasId}`,
  input: '/cnpc/gas/import',
  warningData: '/cnpc/gas/error_data'
})

export const emptyTank = Object.freeze({
  basUrl: '/cnpc/gastank/empty/list'
})

export const map = Object.freeze({
  basUrl: '/sql/query',
  station1Sales: '/station1/sales',
  getSaleByName: '/sql/getSaleByStationName',
  getDepot1ByStatus: '/sql/getDepot1ByStatus'
})

export const planProgress = Object.freeze({
  basUrl: '/cnpc/gas/order/execution/distribution'
})

export const planCompared = Object.freeze({
  basUrl: '/cnpc/gas/order/excuteCompare'
})

export const gasTank = Object.freeze({
  basUrl: '/cnpc/gas/tank',
  parmUrl2: (gasId) => `/cnpc/gas/${gasId}/tank`,
  parmUrl: (id) => `/cnpc/gas/tank/${id}`,
  merge: '/cnpc/gastank/merge',
  gasChooseList: '/cnpc/gastank/list',
  updateGasTankStatus: '/cnpc/gastank/status'
})

export const gasTankError = Object.freeze({
  basUrl: '/cnpc/gastank/error/status/list',
  getWarningOilTank: '/cnpc/gastank/error/oil/list',
  updateTank: '/cnpc/gastank/gas/tanks',
  getYwy: '/cnpc/gastank/gas/tank/ywy'
})

export const depot = Object.freeze({
  basUrl: '/cnpc/depot',
  outputTemplate: '/cnpc/depot/import/template',
  parmUrl: (id) => `/cnpc/depot/${id}`,
  inputUrl: '/cnpc/depot/import',
  updateOil: '/cnpc/depot/oiltype'
})

export const depotRule = Object.freeze({
  basUrl: '/cnpc/depot/rule',
  parmUrl: (id) => `/cnpc/depot/rule/${id}`
})

export const depotOilRule = Object.freeze({
  basUrl: '/cnpc/depot/oil/info',
  parmUrl: (id) => `/cnpc/depot/oil/info/${id}`
})

export const depotDailyOil = Object.freeze({
  basUrl: '/cnpc/depot/oil/daily',
  update: `/cnpc/depot/oil/daily/upset`,
  del: (id) => `/cnpc/depot/oil/daily/${id}`
})

export const gasGroupOut = Object.freeze({
  basUrl: `/cnpc/group/oil/daily`,
  update: `/cnpc/group/oil/daily/upset`,
  del: (id) => `/cnpc/group/oil/daily/${id}`
})

export const gatePass = Object.freeze({
  type: `/cnpc/gate/pass/type`
})

export const driver = Object.freeze({
  basUrl: '/cnpc/driver',
  parmUrl: (id) => `/cnpc/driver/${id}`
})

export const car = Object.freeze({
  basUrl: '/cnpc/car',
  parmUrl: (id) => `/cnpc/car/${id}`,
  updateCarBin: (carId) => `cnpc/car/carbin/edit/${carId}`,
  outputTemplate: '/cnpc/car/import/template',
  inputUrl: '/cnpc/car/import',
  carRefer: '/cnpc/car/refer'
})

export const invicing = Object.freeze({
  basUrl: '/cnpc/gas/daily',
  parmUrl: (id) => `/cnpc/gas/daily/${id}`,
  inputUrl: '/cnpc/gas/daily/batch',
  countError: 'cnpc/gas/daily/error/rank',
  gasDailyError: 'cnpc/gas/daily/error/detail',
  getNotReportData: '/cnpc/gas/tank/not/report'
})

export const carMonth = Object.freeze({
  basUrl: '/cnpc/car/monthly',
  udpate: '/cnpc/car/monthly/upset'
})

// 异常警告数据 add by hunj
export const warning = Object.freeze({
  basUrl: '/cnpc/gasdaily/alarm',
  getData: '/cnpc/gastank/warning',
  getHisData: '/cnpc/gastank/warning/his',
  updateGasTankStatus: (id, status) => `/cnpc/gastank/warning/${id}/${status}`,
  addDeal: '/cnpc/gastank/warning/deal',
  getDeal: (id) => `/cnpc/gastank/warning/deal/${id}`,
  dealNew: '/cnpc/gastank/warning/deal/plan',
  dealNewParmUrl: (id) => `/cnpc/gastank/warning/deal/plan/${id}`,
  getYcData: '/cnpc/gastank/overflow',
  getHisSaleWarning: '/cnpc/pre/daily/diff',
  getTodaySaleWarning: '/cnpc/current/pre/diff'
})

export const invicingCheck = Object.freeze({
  basUrl: '/cnpc/gas/daily',
  inputUrl: '/cnpc/gas/daily/batch',
  update: '/cnpc/gas/upd/check',
  downFile: '/cnpc/otherbus/excel/errorDaily',
  getYwyData: '/cnpc/gas/daily/real/info'
})

export const gasSale = Object.freeze({
  getSale: '/cnpc/gas/daily/out/volume/list',
  updatePreSale: (id) => `/cnpc/gas/daily/pre/out/volume/${id}`
})

export const gasSaleWarning = Object.freeze({
  basUrl: '/cnpc/gas/saleWarning',
  daySale: '/cnpc/gas/daily/sale/list'
})

export const carMonitor = Object.freeze({
  basUrl: '/cnpc/car/gps/status',
  getCarWay: '/cnpc/car/gps'
})

export const gasOrder = Object.freeze({
  basUrl: '/cnpc/gas/order',
  parmUrl: (id) => `/cnpc/gas/order/${id}`,
  updateIsSend: (groupId, dateStr, rate) => `/cnpc/gas/order/upd/batch/${groupId}/${dateStr}/${rate}`,
  prediction: '/cnpc/gas/prediction',
  predictionStatus: '/cnpc/gas/prediction/status',
  clearData: (sendTime, groupId) => `/cnpc/gas/prediction/${sendTime}/${groupId}`,
  outPut: '/cnpc/gas/order/excel',
  confirm: 'cnpc/gas/order/confirm'
})

export const carSign = Object.freeze({
  basUrl: '/cnpc/car/sign',
  signUrl: '/cnpc/car/sign/batch',
  parmUrl: (id) => `/cnpc/car/sign/${id}`
})

export const adjustOrder = Object.freeze({
  getCar: '/cnpc/car/available',
  updateMatchStatus: (status) => `/cnpc/gas/order/matchStatus/${status}`,
  validateCar: (groupId, carId, sendTime) => `/cnpc/gas/order/validate/car/${groupId}/${carId}/${sendTime}`
})

export const planOrder = Object.freeze({
  down: (sendTime, groupId) => `/cnpc/gas/order/route/dispatch/${sendTime}/${groupId}`,
  basUrl: '/cnpc/gas/order/route/send',
  parmUrl: (id) => `/cnpc/gas/order/route/send/${id}`,
  output: '/cnpc/gas/order/route/send/export'
})

export const routerOrder = Object.freeze({
  basUrl: '/cnpc/gas/routeOrder',
  parmUrl: (id) => `/cnpc/gas/routeOrder/${id}`,
  updateSort: (id, sort) => `/cnpc/gas/routeOrder/${id}/sort/${sort}`,
  matchOrder: '/cnpc/gas/matching',
  matchStatus: '/cnpc/gas/matching/status',
  outPut: '/cnpc/otherbus/excel/distribution',
  outPut2: '/cnpc/otherbus/excel/router/order/demand',
  outPutCar: '/cnpc/otherbus/excel/router/order/car/agent/demand',
  outPutQS: '/cnpc/otherbus/excel/router/order/province/demand',
  outPutMx: '/cnpc/otherbus/route/order',
  getDataByGasOrderId: (gasOrderId) => `/cnpc/gas/order/router/${gasOrderId}`,
  getDataByInfo: '/cnpc/gas/order/router/bytime',
  updateData: (id) => `/cnpc/gas/order/route/${id}`,
  clearData: (sendTime, groupId) => `/cnpc/gas/order/routeList/${sendTime}/${groupId}`,
  inputUrl: 'cnpc/gas/order/route/import',
  count: '/cnpc/gas/order/sum/byoil',
  addOne: '/cnpc/gas/route/order',
  updateOne: (id) => `/cnpc/gas/route/order/${id}`,
  check: '/cnpc/gas/route/order/check',
  revoke: '/cnpc/gas/route/order/revoke'
})

export const ajustRouterOrder = Object.freeze({
  basUrl: 'cnpc/adjust/gas/route/order',
  delUrl: (id, str) => `cnpc/adjust/gas/route/order/${id}/${str}`,
  parmUrl: (id) => `cnpc/adjust/gas/route/order/${id}`
})

export const routerOrderRecord = Object.freeze({
  basUrl: 'cnpc/gas/route/order/record',
  getRecord: 'cnpc/gas/route/order/record/name'
})

export const dictionary2 = Object.freeze({
  basUrl: '/cnpc/dictionary/list',
  parmUrl: (id) => `/cnpc/dictionary/upd/${id}`
})

export const platformWarn = Object.freeze({
  basUrl: '/cnpc/middle/platform/warn'
})

export const distribution = Object.freeze({
  basUrl: '/cnpc/gas/distribution',
  parmUrl: (id) => `/cnpc/gas/distribution/${id}`,
  input: '/cnpc/gas/distribution/batch',
  updateInTime: '/cnpc/gas/daily/phone/upd/gasDistribution',
  update: (id) => `/cnpc/gas/distribution/upd/${id}`,
  sysWriteoff: (date, groupId) => `cnpc/gas/distribution/verify/${date}/${groupId}`,
  writeoffUpdate: '/cnpc/gas/distribution/verify/man',
  output: '/cnpc/gas/distribution/way/export',
  gasTransfer: '/cnpc/gasTransfer/add',
  getByPsdNo: '/cnpc/gas/distribution/list/by/ids'
})

export const globParm = Object.freeze({
  getGroupAreas: '/cnpc/area/inuse',
  getGroupAgents: '/cnpc/car/agent/inuse'
})

export const gastankEmergency = Object.freeze({
  basUrl: '/cnpc/gastank/emergency',
  parmUrl: (id) => `/cnpc/gastank/emergency/${id}`
})

export const planReport = Object.freeze({
  basUrl: '/cnpc/total/plan/report'
})

export const oilType = Object.freeze({
  basUrl: '/cnpc/oiltype',
  parmUrl: (id) => `/cnpc/oiltype/${id}`
})

export const matchParm = Object.freeze({
  basUrl: '/cnpc/group/config',
  parmUrl: (id) => `/cnpc/group/config/${id}`
})

export const piChart = Object.freeze({
  basUrl: '/cnpc/gas/pi/order/pic',
  newUrl: '/cnpc/pi/line',
  his: '/cnpc/his/pi/line',
  algo: (id) => `/cnpc/cache/kc/line/${id}`,
  getData: '/cnpc/api/line/empty/hour/v2',
  getTotalData: 'cnpc/total/pi/line'
})

export const monthPlan = Object.freeze({
  basUrl: '/cnpc/total/month/plan'
})

export const yearData = Object.freeze({
  basUrl: '/cnpc/total/year/data'
})

export const carRule = Object.freeze({
  basUrl: '/cnpc/carRule',
  parmUrl: (id) => `/cnpc/carRule/${id}`,
  input: '/cnpc/car/excel/import/rule'
})

export const gasRule = Object.freeze({
  basUrl: '/cnpc/gasRule',
  parmUrl: (id) => `/cnpc/gasRule/${id}`,
  input: '/cnpc/gasRule/excel/import'
})

export const mapDistribution = Object.freeze({
  getCarRouter: '/cnpc/car/locus/car'
})

export const gasDemand = Object.freeze({
  basUrl: '/cnpc/gas/require',
  inputUrl: '/cnpc/otherbus/excel/custom/requireGoods'
})

export const carIOCard = Object.freeze({
  basUrl: '/cnpc/car/keyCard',
  parmUrl: (id) => `/cnpc/car/keyCard/${id}`
})

export const driverIOCard = Object.freeze({
  basUrl: '/cnpc/driver/keyCard',
  parmUrl: (id) => `/cnpc/driver/keyCard/${id}`
})

export const gasPiOrder = Object.freeze({
  getData: (gasOrderId) => `/cnpc/gas/pi/order/${gasOrderId}`,
  updateData: (gasOrderId) => `/cnpc/gas/pi/order/batch/${gasOrderId}`,
  outPut: '/cnpc/otherbus/excel/demand',
  outPut2: '/cnpc/otherbus/excel/demand2',
  count: '/cnpc/gas/pi/order/sum'
})

export const piGasTankStatus = Object.freeze({
  basUrl: '/cnpc/gas/tank/order/info',
  getDistribution: '/cnpc/gas/distribution/pi'
})

export const importExcel = Object.freeze({
  basUrl: '/station1/import'
})

export const carLine = Object.freeze({
  basUrl: '/cnpc/car/line',
  plan: '/cnpc/plan/arrive/time'
})



// WEBPACK FOOTER //
// ./src/api/url.js